

































import { Component, Prop, Vue } from "vue-property-decorator";
import MTextField from "../utility/mmmint/MTextField.vue";
import NumberplateForm from "../utility/NumberplateForm.vue";
import { MrfiktivSharedPersonViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";

@Component({
  components: { NumberplateForm, MTextField }
})
class SharedContentContactCard extends Vue {
  @Prop()
  contacts!: MrfiktivSharedPersonViewModelGen[];
}

export default SharedContentContactCard;
